import React from "react";
import { addLeadingZero } from "../../../../utils/math";
import { AnswersType, ParticipantExamQuestion } from "../../../../types/question";
import { TRANSLATION_CONFIG } from "../../../../utils/consts/translation";
import { useTranslation } from "react-i18next";
import { Button } from "../../../atom/Button";
import { SummaryStateType } from "../../../../types/components";
import { ResetAlt } from "@carbon/icons-react";

interface QuestionItemSummaryProps {
  questions: ParticipantExamQuestion[];
  flags: Record<number, boolean>;
  answers: AnswersType;
  index: number;
  question: ParticipantExamQuestion;
  setCurrentQuestion: React.Dispatch<React.SetStateAction<number>>;
  setIsSummary: React.Dispatch<React.SetStateAction<SummaryStateType>>;
}

export const QuestionItemSummary = ({
  flags,
  questions,
  index,
  answers,
  question,
  setCurrentQuestion,
  setIsSummary,
}: QuestionItemSummaryProps) => {
  const { t } = useTranslation(TRANSLATION_CONFIG.appNamespace);
  const filledFlag = flags[questions[index]?.id];
  const isAnswered = Boolean(answers[question.id]);
  const statusText = isAnswered ? t("Answered") : t("Unanswered");

  const exam_question = question?.exam_question;

  return (
    <li
      onClick={() => console.log(index)}
      className={`group flex items-center justify-between py-2 pr-8 pl-10 pt-2 cursor-pointer text-center transition-colors bg-white`}>
      <div className="flex justify-between items-center w-full">
        <div className="flex items-center gap-x-10">
          <p
            className={`text-center text-[24px] font-light leading-[33.6px] tracking-[2px] [font-variant-numeric:lining-nums_tabular-nums] p-2 transition-colors text-gray-376 group-hover:bg-ghost-110 group-hover:text-black group-hover:rounded-full`}>
            {addLeadingZero(index + 1)}
          </p>
          <p
            className={`overflow-hidden max-w-[1000px] text-ellipsis text-[16px] font-medium leading-[22.4px] tracking-[0.2px] text-left group-hover:text-black "text-gray-375"`}>
            {exam_question?.question_text}
          </p>
        </div>
        <div className="flex items-center gap-x-2">
          <div className="hidden group-hover:flex">
            <Button
              type="rounded"
              label={t("Return")}
              leftIcon={<ResetAlt className="w-[15px] h-[16px" color="black" />}
              onClick={() => {
                setCurrentQuestion(index);
                setIsSummary({ filter: "all", state: false });
              }}
              additionalClassName="max-w-fit"
            />
          </div>
          {filledFlag && (
            <p className="px-4 py-0 text-[15px] font-medium text-red-500 bg-red-100 rounded-full">
              {t("Flagged")}
            </p>
          )}
          <p
            className={`px-4 py-0 font-medium rounded-full text-[15px] ${
              isAnswered
                ? "text-gray-550 bg-ghost-110"
                : "text-ominimo-400 bg-ominimo-400-transparent"
            }`}>
            {statusText}
          </p>
        </div>
      </div>
    </li>
  );
};
